import { createContext, useContext } from 'react';

export const KioskContext = createContext(null);

/**
 * Safe to call anywhere: on a normal laptop there is no KioskProvider value, so
 * this returns `isKiosk: false` instead of throwing. Screens that want to behave
 * differently on a public terminal can just read `isKiosk`.
 */
export function useKiosk() {
  return useContext(KioskContext) ?? { isKiosk: false, terminal: null, locked: false, secondsLeft: null, lock: () => {} };
}
